import React from "react";
import {CarzelleTooltip} from "../System/Messages/CarzelleTooltip";

export const CarStatusPill = ({title, explanation, bgColor, foreColor = 'text-white', Icon = null, className = "px-2"}) => {
    return (
        <CarzelleTooltip message={explanation} allowHtml={true}>
            <div className={`py-1 px-2 flex items-center w-full justify-center rounded whitespace-nowrap ${bgColor} ${className} ${foreColor}`}>
                <div>{title}</div>
                {Icon && <Icon className="w-4 h-4 ml-1"/>}
            </div>
        </CarzelleTooltip>
    )
}